import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Editable WhatsApp contact number; used for both the admin store number and a merchant's own number
export const WhatsAppNumberEditor = ({ endpoint, method = 'PUT', initialValue = '', headers, onSaved, dark = false, testIdPrefix }) => {
  const [value, setValue] = useState(initialValue || '');
  const [saving, setSaving] = useState(false);

  useEffect(() => { setValue(initialValue || ''); }, [initialValue]);

  const save = async () => {
    const digits = value.replace(/\D/g, '');
    if (value.trim() && (digits.length < 8 || digits.length > 15)) {
      toast.error('Enter a valid WhatsApp number with country code, e.g. +234 801 234 5678');
      return;
    }
    setSaving(true);
    try {
      const res = await fetch(`${API}${endpoint}`, {
        method,
        headers: { 'Content-Type': 'application/json', ...headers },
        body: JSON.stringify({ whatsapp: value.trim() }),
      });
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || 'Could not save');
      toast.success('WhatsApp number saved');
      onSaved?.(value.trim());
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  const inputCls = dark
    ? 'bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500'
    : 'bg-background border-input';

  return (
    <div className="flex gap-2">
      <input
        type="tel"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="+234 801 234 5678"
        className={`flex-1 rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#25D366] ${inputCls}`}
        data-testid={`${testIdPrefix}-input`}
      />
      <button
        type="button"
        onClick={save}
        disabled={saving}
        className="inline-flex items-center gap-2 rounded-lg bg-[#25D366] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#1EBE5A] disabled:opacity-60"
        data-testid={`${testIdPrefix}-save-btn`}
      >
        {saving && <Loader2 className="w-4 h-4 animate-spin" />}
        Save
      </button>
    </div>
  );
};

export default WhatsAppNumberEditor;
